/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B020040 専用伝票発行
 */

import { Box } from "@mui/material";
import {
  B000150TokuiNmFrom,
  B000150TokuiNmTo,
  catchFileError,
} from "clients/rest";
import { B020040Print, B020040Request } from "clients/rest/b020/B020040";
import {
  SText,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  STextField,
  SCodeSelect,
  msgState,
  SDateField,
} from "components";
import { getClientMessage } from "messages";
import { labels } from "messages/labels";
import { B000150 } from "pages/b000/B000150";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { download, printed } from "services";
import { denpyoshubetsuCdValue } from "services/codes";
import { focusState, useFocus } from "states";
import {
  DenpyoshubetsuCd,
  getSCode,
  SCode,
  UridenpyohakozumiKbn,
} from "../../messages/codes";

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  uridenpyohakozumiKbn: SCode;
  shukaYmd: string;
  uridenpyoNoFrom: string;
  uridenpyoNoTo: string;
  juchudenpyoNoFrom: string;
  juchudenpyoNoTo: string;
  tokuiCdFrom: string;
  tokuishitenCdFrom: string;
  tokuiNmFrom: string;
  tokuiCdTo: string;
  tokuishitenCdTo: string;
  tokuiNmTo: string;
  denpyoshubetsuCdKbn: SCode;
}>;

const defaultFields: Fields = {
  uridenpyohakozumiKbn: getSCode(UridenpyohakozumiKbn, "0"),
  shukaYmd: "",
  uridenpyoNoFrom: "",
  uridenpyoNoTo: "",
  juchudenpyoNoFrom: "",
  juchudenpyoNoTo: "",
  tokuiCdFrom: "",
  tokuishitenCdFrom: "",
  tokuiNmFrom: "",
  tokuiCdTo: "",
  tokuishitenCdTo: "",
  tokuiNmTo: "",
  denpyoshubetsuCdKbn: getSCode(DenpyoshubetsuCd, "0"),
};

const focusId = "B020040";

// B020030 売上明細照会
export const B020040 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // エラー表示
  const setMsg = useSetRecoilState(msgState);
  // 画面遷移
  const navigate = useNavigate();

  // 初期表示イベント
  useEffect(() => {
    focus(1);
  }, []);

  // 印刷ボタン押下イベント
  const handlePrint = () => {
    // フィールドの値取得
    const fields = methods.getValues();

    // 選択値に応じた伝票種別コードの設定
    let paramDenpyoshubetsuCd: string;
    if (fields.denpyoshubetsuCdKbn!.value === "0") {
      paramDenpyoshubetsuCd = denpyoshubetsuCdValue.apjDenpyo;
    } else if (fields.denpyoshubetsuCdKbn!.value === "1") {
      paramDenpyoshubetsuCd = denpyoshubetsuCdValue.cs1Denpyo;
    } else if (fields.denpyoshubetsuCdKbn!.value === "2") {
      paramDenpyoshubetsuCd = denpyoshubetsuCdValue.cs2Denpyo;
    } else if (fields.denpyoshubetsuCdKbn!.value === "3") {
      paramDenpyoshubetsuCd = denpyoshubetsuCdValue.cstypeDenpyo;
    } else if (fields.denpyoshubetsuCdKbn!.value === "4") {
      paramDenpyoshubetsuCd = denpyoshubetsuCdValue.kaguDenpyo;
    } else if (fields.denpyoshubetsuCdKbn!.value === "5") {
      paramDenpyoshubetsuCd = denpyoshubetsuCdValue.hyakatenDenpyo;
    } else if (fields.denpyoshubetsuCdKbn!.value === "6") {
      paramDenpyoshubetsuCd = denpyoshubetsuCdValue.sinbido2Denpyo;
    } else if (fields.denpyoshubetsuCdKbn!.value === "7") {
      paramDenpyoshubetsuCd = denpyoshubetsuCdValue.sanrioDenpyo;
    } else if (fields.denpyoshubetsuCdKbn!.value === "8") {
      paramDenpyoshubetsuCd = denpyoshubetsuCdValue.tegakiDenpyo;
    }

    // 印刷パラメータ作成
    const param: B020040Request = {
      uridenpyohakozumiKbn: fields.uridenpyohakozumiKbn?.value!,
      shukaYmd: fields.shukaYmd,
      uridenpyoNoFrom: fields.uridenpyoNoFrom,
      uridenpyoNoTo: fields.uridenpyoNoTo,
      juchudenpyoNoFrom: fields.juchudenpyoNoFrom,
      juchudenpyoNoTo: fields.juchudenpyoNoTo,
      tokuiCdFrom: fields.tokuiCdFrom,
      tokuishitenCdFrom: fields.tokuishitenCdFrom,
      tokuiCdTo: fields.tokuiCdTo,
      tokuishitenCdTo: fields.tokuishitenCdTo,
      denpyoshubetsuCd: paramDenpyoshubetsuCd!,
    };
    // API呼び出し
    B020040Print(param)
      .then((response) => {
        if (printed(response)) {
          setMsg(getClientMessage("B020040_001"));
        } else {
          download(response);
          setMsg(getClientMessage("B020040_002"));
        }
      })
      .catch((reason) => {
        catchFileError(reason, navigate, setMsg);
      });
  };

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="専用伝票発行"
        gridTemplateColumns="6rem 6rem 5rem 1rem 14rem 1rem 5rem 5rem 15rem "
      >
        <SLabel>発行区分</SLabel>
        <SCodeSelect
          name="uridenpyohakozumiKbn"
          label="発行区分"
          options={UridenpyohakozumiKbn}
          gridColumn="span 2"
          {...register(1)}
        />

        <SLabel gridColumn="1">発送日</SLabel>
        <SDateField name="shukaYmd" {...register(2)} gridColumn="span 2" />

        <SLabel gridColumn="1">売上No.</SLabel>
        <SNumberField
          name="uridenpyoNoFrom"
          laebl="売上No.(From)"
          code
          size={10}
          gridColumn="span 2"
          {...register(3)}
        />
        <SText>～</SText>
        <SNumberField
          name="uridenpyoNoTo"
          label="売上No.(To)"
          code
          size={10}
          {...register(4)}
        />

        <SLabel gridColumn="1">受注No.</SLabel>
        <SNumberField
          name="juchudenpyoNoFrom"
          laebl="受注No.(From)"
          code
          size={10}
          {...register(5)}
          gridColumn="span 2"
        />
        <SText>～</SText>
        <SNumberField
          name="juchudenpyoNoTo"
          label="受注No.(To)"
          code
          size={10}
          {...register(6)}
        />

        <SLabel gridColumn="1">得意先</SLabel>
        <SNumberField
          name="tokuiCdFrom"
          label="得意先コード(From)"
          code
          size={6}
          onBlur={() => B000150TokuiNmFrom(methods, navigate, setMsg)}
          {...register(7)}
        />
        <SNumberField
          name="tokuishitenCdFrom"
          label="得意先支店コード(From)"
          code
          size={4}
          dialog={<B000150 />}
          handleSubmit={(data: any) => {
            methods.setValue("tokuiCdFrom", data.tokuiCd);
            methods.setValue("tokuishitenCdFrom", data.tokuishitenCd);
            methods.setValue("tokuiNmFrom", data.tokuiNmr);
          }}
          onBlur={() => B000150TokuiNmFrom(methods, navigate, setMsg)}
          {...register(8)}
        />
        <STextField
          name="tokuiNmFrom"
          label="得意先名(From)"
          size={40}
          disabled
          gridColumn="span 2"
        />
        <SText>～</SText>
        <SNumberField
          name="tokuiCdTo"
          laebl="得意先コード(To)"
          code
          size={6}
          onBlur={() => B000150TokuiNmTo(methods, navigate, setMsg)}
          {...register(9)}
        />
        <SNumberField
          name="tokuishitenCdTo"
          label="得意先支店コード(To)"
          code
          size={4}
          dialog={<B000150 />}
          handleSubmit={(data: any) => {
            methods.setValue("tokuiCdTo", data.tokuiCd);
            methods.setValue("tokuishitenCdTo", data.tokuishitenCd);
            methods.setValue("tokuiNmTo", data.tokuiNmr);
          }}
          onBlur={() => B000150TokuiNmTo(methods, navigate, setMsg)}
          {...register(10)}
        />
        <STextField name="tokuiNmTo" label="得意先名(To)" size={40} disabled />
        <SLabel gridColumn="1" required>
          伝票種別
        </SLabel>
        <SCodeSelect
          name="denpyoshubetsuCdKbn"
          label="伝票種別コード"
          options={DenpyoshubetsuCd}
          gridColumn="span 2"
          required
          {...register(11)}
        />

        <Box gridColumn="span 5" />

        <SNormalButton
          label={labels.buttons.print}
          align="right"
          onClick={handlePrint}
          {...register(12)}
        />
      </SFrame>
    </FormProvider>
  );
};
